import React, {ReactElement} from 'react';
import humanizeString from 'humanize-string';
import Typography from '@material-ui/core/Typography';
import {IngestConfigRow} from './Redux/IngestConfigsReducerTypes';

export const render = (key: keyof IngestConfigRow) => (
    row: IngestConfigRow
): ReactElement => {
    const humanStatus = key === 'status' ? humanizeString(row[key]) : row[key];
    switch (row.status) {
        case 'INACTIVE':
            return <Typography className="status-grey">{humanStatus}</Typography>;

        default:
            return <>{humanStatus}</>;
    }
};

enum Keys {
    name = 'name',
    contentPartner = 'contentPartner',
    ingestType = 'ingestType',
    labPartner = 'labPartner',
    status = 'status',
    polling = 'polling',
}

export default [
    {
        dataKey: Keys.name,
        title: 'Ingest Config',
        render: render(Keys.name),
    },
    {
        dataKey: Keys.contentPartner,
        title: 'Content Partner',
        render: render(Keys.contentPartner),
    },
    {
        dataKey: Keys.ingestType,
        title: 'Ingest Type',
        render: render(Keys.ingestType),
    },
    {
        dataKey: Keys.labPartner,
        title: 'Lab partner',
        render: render(Keys.labPartner),
    },
    {
        dataKey: Keys.status,
        title: 'Status',
        render: render(Keys.status),
    },
    {
        dataKey: Keys.polling,
        title: 'Polling Interval',
        render: render(Keys.polling),
    },
];
